"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.GetDisplayNameFromLookup = GetDisplayNameFromLookup;
exports.GetProjectMembers = GetProjectMembers;
exports.ParseDueDate = ParseDueDate;
exports.getDayPickerDate = getDayPickerDate;
exports.getClearedDate = getClearedDate;
exports.getDaysForwardDate = getDaysForwardDate;
exports.getWeeksForwardDate = getWeeksForwardDate;
exports.getParsedDate = getParsedDate;
exports.getNormalizedDate = getNormalizedDate;
exports.isDayName = isDayName;
exports.getDayNameDate = getDayNameDate;
exports.isChecklistDueForRenew = isChecklistDueForRenew;
exports.getDisplayNameFromLookup = getDisplayNameFromLookup;
exports.getProjectLayoutType = getProjectLayoutType;
exports.TaskAlphabeticalSorter = TaskAlphabeticalSorter;
exports.TaskCompletedSorter = TaskCompletedSorter;
exports.TaskPrioritySorter = TaskPrioritySorter;
exports.TaskDueDateSorter = TaskDueDateSorter;
exports.TaskDateAddedSorter = TaskDateAddedSorter;
exports.TaskAssigneeSorter = TaskAssigneeSorter;
exports.GetUid = GetUid;

var _moment = _interopRequireDefault(require("moment"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var dateFormat = "DD-MM-YYYY";
var LONG_DAY_NAMES = ['monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday', 'sunday'];
var SHORT_DAY_NAMES = ['mon', 'tues', 'tue', 'wed', 'thurs', 'thur', 'fri', 'sat', 'sun'];
var DAY_NAMES = LONG_DAY_NAMES.concat(SHORT_DAY_NAMES);

function GetDisplayNameFromLookup(userId, memberLookup) {
  if (userId === undefined || userId === -1 || userId === "-1" || memberLookup === undefined) {
    return "";
  }

  var displayName = memberLookup[userId];
  return displayName === undefined ? "" : displayName;
}

function GetProjectMembers(members, projectId) {
  if (members === undefined || members.length === 0 || projectId === undefined || projectId === -1) {
    return [];
  }

  var filteredMembers = [];
  filteredMembers = members.filter(function (item) {
    return item.project === projectId;
  });
  return filteredMembers;
}

function ParseDueDate(isComplete, dueDate) {
  if (isComplete) {
    return {
      type: "complete",
      text: ""
    };
  }

  if (dueDate === "") {
    return {
      type: "unset",
      text: ""
    };
  }

  var dueDate = new _moment["default"](dueDate).hours(13);
  var currentDate = new _moment["default"]();
  var difference = dueDate.diff(currentDate, 'days'); // Today.

  if (dueDate.isSame(currentDate, 'day')) {
    return {
      type: "today",
      text: "Today"
    };
  } // Tomorrow


  if (dueDate.calendar(currentDate).includes("Tomorrow")) {
    return {
      type: "soon",
      text: 1 + "d"
    };
  } // Overdue


  if (difference < 0) {
    return {
      type: "overdue",
      text: "Due"
    };
  } // Later On


  if (difference >= 1 && difference <= 6) {
    return {
      type: "later",
      text: difference + 1 + "d"
    };
  } // At least a Week out.


  if (difference >= 7) {
    return {
      type: "later",
      text: Math.round(difference / 7) + "w"
    };
  } else {
    return {
      type: "unset",
      text: ""
    };
  }
}

function getDayPickerDate(day) {
  return getNormalizedDate(new _moment["default"](day, dateFormat));
}

function getClearedDate() {
  return "";
}

function getDaysForwardDate(daysForward) {
  var daysForwardNumber = Number.parseInt(daysForward);
  return getNormalizedDate(new _moment["default"](new Date(), dateFormat).add(daysForwardNumber, 'd'));
}

function getWeeksForwardDate(weeksForward) {
  return getNormalizedDate(new _moment["default"](new Date(), dateFormat).add(weeksForward, 'w'));
}

function getParsedDate(date) {
  return getNormalizedDate(new _moment["default"](date, ["DD-MM-YY", "DD-MM-YYYY", "DD-MM"]));
}

function getNormalizedDate(momentDate) {
  return momentDate.startOf('day').hours(2).toISOString();
}

function isDayName(value) {
  return DAY_NAMES.some(function (name) {
    return name === value;
  });
}

function getDayNameDate(dayName) {
  var dayNumber = (0, _moment["default"])(dayName, 'dddd').startOf('day').day();
  var currentDayNumber = (0, _moment["default"])().day();

  if (dayNumber > currentDayNumber) {
    return getDaysForwardDate(dayNumber - currentDayNumber);
  } else {
    return getNormalizedDate((0, _moment["default"])().endOf('week').add(dayNumber + 1, 'd'));
  }
}

function isChecklistDueForRenew(checklistSettings) {
  var initialStartDate = checklistSettings.initialStartDate;
  var lastRenewDate = checklistSettings.lastRenewDate;
  var renewInterval = checklistSettings.renewInterval; // Determine the next renew Date. if lastRenewDate is blank, that means that the first renew hasn't occured yet. So just use
  // the inititalStartDate. Otherwise, combine lastRenewDate and renewInterval to get next Renew Date.

  var nextRenewDate = {};

  if (lastRenewDate === "") {
    nextRenewDate = (0, _moment["default"])(initialStartDate);
  } else {
    nextRenewDate = (0, _moment["default"])(lastRenewDate).add(renewInterval, 'd');
  }

  var currentDate = (0, _moment["default"])();
  return nextRenewDate.diff(currentDate, 'seconds') < 0;
}

function getDisplayNameFromLookup(lookup, userId) {
  if (lookup[userId] !== undefined) {
    return lookup[userId];
  } else {
    return "";
  }
}

function getProjectLayoutType(projectId, members, userId) {
  var filteredMembers = members.filter(function (item) {
    return item.project === projectId;
  });
  var member = filteredMembers.find(function (item) {
    return item.userId === userId;
  });

  if (member === undefined || member.projectLayoutType === undefined) {
    // Return the Global Layout.
    return 'global';
  } else {
    // Return the Users local Layout.
    return member.projectLayoutType;
  }
}

function TaskAlphabeticalSorter(a, b) {
  var textA = a.taskName.toUpperCase();
  var textB = b.taskName.toUpperCase();
  return textA < textB ? -1 : textA > textB ? 1 : 0;
}

function TaskCompletedSorter(a, b) {
  if (a.isComplete > b.isComplete) {
    return 1;
  }

  if (a.isComplete < b.isComplete) {
    return -1;
  }

  return TaskDateAddedSorter(a, b);
}

function TaskPrioritySorter(a, b) {
  if (a.isHighPriority > b.isHighPriority) {
    return -1;
  }

  if (a.isHighPriority < b.isHighPriority) {
    return 1;
  }

  return TaskDateAddedSorter(a, b);
}

function TaskDueDateSorter(a, b) {
  var dueDateA = a.dueDate.length === 0 ? Infinity : new Date(a.dueDate);
  var dueDateB = b.dueDate.length === 0 ? Infinity : new Date(b.dueDate);

  if (dueDateA > dueDateB) {
    return 1;
  }

  if (dueDateA < dueDateB) {
    return -1;
  }

  return TaskDateAddedSorter(a, b);
}

function TaskDateAddedSorter(a, b) {
  var dateAddedA = new Date(a.dateAdded);
  var dateAddedB = new Date(b.dateAdded);
  return dateAddedA - dateAddedB;
}

function TaskAssigneeSorter(a, b) {
  var aName = (a.assignedTo === undefined || a.assignedTo === -1 ? "aaa" : a.assignedTo).toUpperCase();
  var bName = (b.assignedTo === undefined || b.assignedTo === -1 ? "aaa" : b.assignedTo).toUpperCase();

  if (aName > bName) {
    return -1;
  }

  if (aName < bName) {
    return 1;
  }

  return TaskDateAddedSorter(a, b);
}

var uuidv1 = require('uuid/v1');

function GetUid() {
  return uuidv1();
}



//////////////////
// WEBPACK FOOTER
// ../handball-libs/libs/pounder-utilities/index.js
// module id = 87
// module chunks = 0